import { render } from "./staged-form.component.vue?vue&type=template&id=66e11f62&scoped=true"
import script from "./staged-form.component.vue?vue&type=script&lang=js"
export * from "./staged-form.component.vue?vue&type=script&lang=js"

import "./staged-form.component.vue?vue&type=style&index=0&id=66e11f62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e11f62"]])

export default __exports__